<template>
  <div>
    <!------------- start toast / snackbar ---------------->
    <success-toast-component :SuccessToast="SuccessToast" @close="close" />
    <error-toast-component :ErrorToast="ErrorToast" @close="close" />
    <!------------ end toast / snackbar----------------->
    <div>
      <v-card flat>
        <!-------- heading and button------------>
        <v-row class="d-flex justify-space-between" flat>
          <v-col md="6" sm="6">
            <h1 class="heading-1 mobile_size_h1">Announcements</h1>
          </v-col>
          <v-col md="6" sm="6">
            <div class="d-flex justify-end">
              <v-card flat class="d-flex justify-end mt-2">
                <!-- <v-btn color="primary">Add new</v-btn> -->
                <v-dialog v-model="add_dialog" persistent max-width="600">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      depressed
                      color="primary"
                      block
                      class="text_style px-6 pa-6"
                      v-bind="attrs"
                      v-on="on"
                      v-if="Permission.Add"
                    >
                      Add new
                    </v-btn>
                  </template>
                  <v-card>
                    <div class="mx-6 py-6 d-flex justify-space-between">
                      <span class="heading-2">
                        <b> Create new annoucement</b></span
                      >
                      <v-icon @click="add_dialog = false">mdi-close</v-icon>
                    </div>
                    <div v-if="add_dialog">
                      <addannouncement @close="close" />
                    </div>
                  </v-card>
                </v-dialog>
              </v-card>
            </div>
          </v-col>
        </v-row>
        <!-------- search----------->
        <v-row class="mt-6">
          <v-col cols="12" md="4" sm="6">
            <v-card flat style="color: #f2f3f9">
              <v-text-field
                dense
                outlined
                prepend-inner-icon="mdi-magnify"
                label="Search"
                single-line
                v-model="search"
              >
              </v-text-field>
            </v-card>
          </v-col>
        </v-row>
        <!------- data table------------>
        <v-card class="mt-4 mb-14" flat outlined>
          <v-data-table
            :headers="headers"
            :search="search"
            :items="GetAnnouncement"
            :hide-default-footer="true"
            :loading="tableLoader"
            loading-text="Loading... Please wait"
            :page.sync="page"
            :items-per-page="displayedItemsPerPage"
            @page-count="pageCount = $event"
          >
            <template v-slot:[`item.index`]="{ index }" class="pa-8">
              <span class="style-text-table"> {{ index + 1 }} </span>
            </template>
            <template v-slot:[`item.Title`]="{ item }" class="pa-8">
              <span class="style-text-table"> {{ item.Title }} </span>
            </template>
            <template v-slot:[`item.Status`]="{ item }">
              <span class="style-text-table">
                <v-chip
                  class="px-8 style-text-table"
                  id="chip"
                  :class="item.Status == 1 ? 'Pending' : 'Publish'"
                  :color="getColor(item.Status)"
                  dark
                >
                  {{ item.Status == 1 ? "Pending" : "Published" }}</v-chip
                >
              </span>
            </template>
            <template v-slot:[`item.PublishDate`]="{ item }" class="pa-8">
              <span class="style-text-table">
                {{ item.PublishDate.split("T")[0] }}
              </span>
            </template>
            <template v-slot:[`item.actions`]="{ item }" class="pa-8">
              <div class="d-flex justify-end mt-4 mb-4 ma-3">
                <!-- <v-icon color="#EAA413" v-if="item.isHidden"
                  >mdi-pin-outline</v-icon
                >
                <v-icon color="transparent" v-else>mdi-pin-outline</v-icon> -->
                <v-btn icon @click="toggleIsPlaying(item.index)">
                  <v-icon v-if="item.isPlaying" color="primary">mdi-eye</v-icon>
                  <v-icon v-else>mdi-eye</v-icon>
                </v-btn>
                <v-menu
                  transition="scroll-y-transition"
                  offset-y
                  color="transparent"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      class="ml-3 pr-8"
                      @click="EditItem(item)"
                      color="#A1A1A6"
                      v-bind="attrs"
                      v-on="on"
                    >
                      mdi-dots-horizontal
                    </v-icon>
                  </template>
                  <v-card flat>
                    <v-list class="px-3 pt-1" color="transparent">
                      <v-btn
                        depressed
                        color="transparent"
                        block
                        v-bind="attrs"
                        v-on="on"
                        class="d-flex justify-start"
                        @click="EditAnnouncment(item)"
                      >
                        <v-icon color="#646464">mdi-pencil</v-icon>
                        <span class="ml-4 text_style">Edit</span>
                      </v-btn>
                    </v-list>
                    <v-list class="px-3 pt-1" color="transparent">
                      <v-btn
                        depressed
                        color="transparent"
                        @click="SeeAnnouncement(item)"
                        block
                        v-bind="attrs"
                        v-on="on"
                        class="d-flex justify-start"
                      >
                        <v-icon color="#646464">mdi-eye</v-icon>
                        <span class="ml-4 text_style">Preview</span>
                      </v-btn>
                    </v-list>
                    <!-- <v-list
                      class="px-3 pt-1"
                      color="transparent"
                      v-if="item.Status == 1"
                    >
                      <v-btn
                        depressed
                        block
                        class="d-flex justify-start"
                        @click="EditAnnouncment(item)"
                      >
                        <v-icon dark>mdi-pencil</v-icon>
                        <span class="ml-4 text_style">Edit </span>
                      </v-btn>
                    </v-list> -->
                    <v-list class="px-3 pt-1" color="transparent">
                      <v-btn
                        depressed
                        color="transparent"
                        block
                        class="d-flex justify-start"
                        @click="DeleteAnnouncement(item.Id)"
                      >
                        <v-icon color="#646464">mdi-delete</v-icon>
                        <span class="ml-4 text_style action_dialog"
                          >Delete</span
                        >
                      </v-btn>
                    </v-list>
                  </v-card>
                </v-menu>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-card>
      <v-card flat class="my-9 d-flex justify-end align-center">
        <span class="text_transform pa-0 ma-0">Per page : </span>
        <v-card flat width="100" class="mx-5">
          <v-select
            :items="ItemsPerPageItems"
            label="Items per page"
            v-model="itemsPerPage"
          ></v-select>
        </v-card>
        <v-pagination
          v-model="page"
          :length="pageCount"
          :total-visible="5"
        ></v-pagination
      ></v-card>
    </div>
    <!----------------------------details diloag------------------------------------>
    <v-dialog
      v-model="infodialog"
      persistent
      max-width="720"
      @click:outside="closeDialog"
    >
      <v-card flat rounded outlined>
        <div flat class="py-8 px-8 d-flex justify-space-between">
          <v-row justify="center">
            <v-col cols="12">
              <v-card flat class="pa-12 text-center text_iner_style">{{
                seeAnnouncement.Title
              }}</v-card>
            </v-col>
          </v-row>
        </div>
        <div>
          <see-announcement
            :infodialog="infodialog"
            :seeAnnouncement="seeAnnouncement"
          />
        </div>
      </v-card>
    </v-dialog>
    <!----------------------------Edit diloag------------------------------------>
    <v-dialog v-model="EditDialog" v-if="EditDialog" persistent max-width="720">
      <v-card>
        <div class="mx-6 py-6 d-flex justify-space-between">
          <span class="heading-2"> <b> Edit annoucement</b></span>
          <v-icon @click="EditDialog = false">mdi-close</v-icon>
        </div>

        <div>
          <addannouncement
            :EditDialog="EditDialog"
            :editItem="editItem"
            @close="close"
          />
        </div>
      </v-card>
    </v-dialog>
    <!----------------------------delete diloag------------------------------------>
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5"> Warning </v-card-title>
        <v-card-text class="index_span_2_style"
          >Are you sure you want to delete?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialog = false">
            Cancel
          </v-btn>
          <v-btn color="red darken-1" text @click="DdialogClose()">
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Addannouncement from "../../components/Announcements/addannouncement.vue";
import seeAnnouncement from "../../components/Announcements/seeAnnouncement.vue";
import ErrorToastComponent from "../../components/Toast/ErrorToast.component.vue";
import SuccessToastComponent from "../../components/Toast/SuccessToast.component.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    seeAnnouncement,
    Addannouncement,
    SuccessToastComponent,
    ErrorToastComponent,
  },
  data() {
    return {
      EditDialog: false,
      ItemsPerPageItems: [10, 50, 100, 200, "All"],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      Permission: {},
      SuccessToast: false,
      ErrorToast: false,
      infodialog: false,
      previewDialog: false,
      dialog: false,
      add_dialog: false,
      isPlaying: false,
      btnloader: false,
      tableLoader: false, // data-table true or false
      search: "",
      DeleteId: 0,
      seeAnnouncement: {
        Title: "",
        Content: "",
        PublishDate: "1111T",
      },
      editItem: {
        Id: 0,
        Title: "",
        Content: "",
        PublishDate: "",
        ShowTo: [],
      },
      headers: [
        { text: "#", value: "index", sortable: false },
        { text: "Title", value: "Title" },
        { text: "Status", value: "Status" },
        { text: "Publish at", value: "PublishDate" },
        { text: "", value: "actions", sortable: false },
      ],
      DataTableOne: [],
    };
  },
  computed: {
    ...mapGetters(["GetUserRolePermissions", "GetAnnouncement"]),
    displayedItemsPerPage() {
      return this.itemsPerPage === "All"
        ? this.GetAnnouncement.length
        : this.itemsPerPage;
    },
  },
  mounted() {
    this.fetchData();
    this.Permission = this.GetUserRolePermissions.RolePermissions.find(
      (x) => x.Module === "Announcements"
    );
    this.tableLoader = true;
    setTimeout(() => {
      (this.DataTableOne = [
        {
          index: "5",
          title: "IT Issue Fixed",
          status: "Publish",
          publish: "11/12/2021",
          isPlaying: false,
        },
        {
          index: "4",
          title: "IT Issue Alert and Important Updates",
          status: "Pending",
          publish: "11/12/2021",
          isPlaying: false,
        },
        {
          index: "3",
          title: "Instructor Roundtable #2 Video and HTML Guide",
          status: "Publish",
          publish: "11/12/2021",
          isPlaying: false,
        },
        {
          index: "2",
          title: "Fundamentals Exam Information",
          status: "Publish",
          publish: "11/12/2021",
          isPlaying: false,
        },
        {
          index: "1",
          title: "Survey: Your Feedback, Our Future",
          status: "Publish",
          publish: "11/12/2021",
          isPlaying: false,
        },
        {
          index: "6",
          title: "IT Issue Alert and Important Updates",
          status: "Pending",
          publish: "11/12/2021",
          isPlaying: false,
        },
      ]),
        (this.tableLoader = false);
    }, 1500);
  },
  methods: {
    closeDialog() {
      this.infodialog = false;
      this.value = false;
    },
    DeleteAnnouncement(id) {
      this.DeleteId = id;
      this.dialog = true;
    },
    fetchData() {
      var obj = {
        page: 1,
        pageSize: "All",
      };
      this.$store.dispatch("GetAnnouncement", obj);
    },
    SeeAnnouncement(item) {
      this.infodialog = true;
      this.seeAnnouncement = item;
    },
    EditAnnouncment(item) {
      this.editItem = item;
      this.EditDialog = true;
    },
    toggleIsPlaying(obj) {
      this.DataTableOne = this.DataTableOne.map((e) => {
        if (e.index === obj) {
          e.isPlaying = !e.isPlaying;

          return e;
        }
        return e;
      });
      this.isPlaying = !this.isPlaying;
    },
    getColor(status) {
      if (status == 1) return "#e5e7ea";
      else return "#0fc965";
    },

    check(status) {
      if (status == "Pending") return "#e5e7ea";
      else return "blue";
    },
    DdialogClose() {
      this.$store.dispatch("DeleteAnnouncement", this.DeleteId).then((res) => {
        if (res.Status) {
          this.fetchData();
          this.dialog = false;
          this.ErrorToast = true;
          setTimeout(() => {
            this.ErrorToast = false;
          }, 1500);
        }
      });
    },
    send() {
      setTimeout(() => {
        this.btnloader = true;
      }, 100);
      setTimeout(() => {
        this.editdialog = false;
        this.btnloader = false;
        this.add_dialog = false;
        this.previewDialog = false;
        this.SuccessToast = true;
      }, 2000);
      setTimeout(() => {
        this.SuccessToast = false;
      }, 3000);
    },
    close() {
      this.SuccessToast = false;
      this.ErrorToast = false;
      this.infodialog = false;
      this.EditDialog = false;
      this.add_dialog = false;
      this.fetchData();
    },
  },
};
</script>

<style scoped>
.style-text-table {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 21px;

  color: #222222;
}
#chip.v-chip.Publish {
  background: rgba(227, 243, 233, 1) !important;
  color: #0fc965;
}
#chip.v-chip.Pending {
  background: #e5e7ea;
  padding: 0 7%;
  color: rgba(74, 74, 74, 1);
}
.text_style {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 16px;
  letter-spacing: 0.25px;
  color: rgba(34, 34, 34, 0.87);
}
.text_iner_style {
  background: linear-gradient(258.18deg, #1091e9 -1.64%, #006ab1 89.64%);
  border-radius: 15px;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 22px;
  color: #ffffff;
}
.v-text-field--outlined >>> fieldset {
  border-color: #e0e0e0;
}
@media screen and (max-width: 430px) {
  .mobile_size_h1 {
    font-size: 6vw;
  }
}
</style>
